export default __webpack_public_path__ + "static/media/phone-svgrepo-com.6c48d180.svg";